import "antd/lib/radio/style";
import Radio from "antd/lib/radio";

export default Radio;
